module.exports = __webpack_public_path__ + "static/img/Solutionimg3.8bd73cc0.jpg";